import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from "@angular/common/http";
import {empty, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Idle } from '@ng-idle/core';
import { ErrorService } from '../error.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MfaService {
  private baseUrl = environment.baseUrl;
  private asgSecurityUrl = environment.asgSecurityUrl;

  constructor(private http: HttpClient, private idle: Idle,private errSer: ErrorService, private router: Router) { }

  generateQrForOrganization(organizationId) {
    let url = environment.asgAdminUrl + `/asg/admin/organizations/${organizationId}/generateSecretKeys`;
    return this.http.put(url, {}).pipe(catchError((error) => {
        this.errSer.stopLoaderAndShowError(error);
        return empty();
    }));
  }

  generateQrForUser(email) {
    let url = environment.asgAdminUrl + `/v1/users/${email}/generateSecretKey`;
    return this.http.put(url, {}).pipe(catchError((error) => {
        this.errSer.stopLoaderAndShowError(error);
        return empty();
    }));
  }

  generateQrForUserForMFA(email) {
    let url = environment.asgAdminUrl + `/public/v1/users/${email}/emailQRCode`;
    return this.http.put(url, {}).pipe(catchError((error) => {
        this.errSer.stopLoaderAndShowError(error);
        return empty();
    }));
  }

  mfaSignOn(otpToken) {
		let params = new HttpParams();
		params = params.append('otpToken', otpToken);
		let url = `${this.asgSecurityUrl}/asg/user/mfa/signon`;
		this.idle.watch();
		return this.http.post(url, null, { 'params': params });
	}

  doMfaLogin(headers, body, token) {
    let options = {
      headers: new HttpHeaders({
          ...headers,
          observe: 'response' as 'body'
      }),
      observe: 'response' as 'body'
    };

    let url = this.asgSecurityUrl + "/asg/mfa/signon?otpToken="+token;

    return this.http.post(url, body, options).pipe(
      map((data) => {
        this.idle.watch();
        return data;
      }),
      catchError((error) => {
        // console.log('error : ', error);
        // if (error && error.error && error.error.message) {

        // }
        this.errSer.stopLoaderAndShowError(error);
        if (
          error == "Your password is expired, please update a new password."
        ) {
          this.router.navigate(["/home/user/changePassword"]);
        }
        return throwError(error);
      })
    );
  }

}
